import { Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';

const SettingsConflictPrompt = ({ reloading, onReload }) => {
    const { t } = useTranslation('vinExtraction');

    return (
        <Alert
            type="warning"
            showIcon
            role="alert"
            message={t('edit.conflictTitle')}
            description={t('edit.conflictDescription')}
            action={
                <Button size="small" loading={reloading} onClick={onReload}>
                    {t('edit.reload')}
                </Button>
            }
        />
    );
};

export default SettingsConflictPrompt;
